import styled from 'styled-components';
import { Input } from '../../input/src/Input.styles';
import { Button } from '../../button/src/Button.styles';
var SearchBar = styled.form.withConfig({
  displayName: "SearchBarstyles__SearchBar",
  componentId: "sc-4p26oj-0"
})(["display:flex;flex-direction:row;position:relative;width:100%;"]);
var SearchInput = styled(Input).withConfig({
  displayName: "SearchBarstyles__SearchInput",
  componentId: "sc-4p26oj-1"
})(["&:hover,&:focus,&:active{border:1px solid ", ";}"], function (props) {
  return props.theme.color.monochrome.base;
});
var ButtonContainer = styled.div.withConfig({
  displayName: "SearchBarstyles__ButtonContainer",
  componentId: "sc-4p26oj-2"
})(["position:relative;margin-left:-2px;"]);
var SearchButton = styled(Button).withConfig({
  displayName: "SearchBarstyles__SearchButton",
  componentId: "sc-4p26oj-3"
})(["border-width:1px;border-radius:0 3px 3px 0;"]);
var SearchIconContainer = styled.div.withConfig({
  displayName: "SearchBarstyles__SearchIconContainer",
  componentId: "sc-4p26oj-4"
})(["left:20px;svg{margin-right:0;}"]);
export { SearchBar, SearchInput, SearchButton, ButtonContainer, SearchIconContainer };